export const COLORS = {
	primaryBlue: "#002557",
	primaryLightBlue: "#01419a",
	primaryGreen: "#0e6655",
    primaryLightGreen: "#1abc9c",
	white: "#fff",
	black: "#000000"
}
export const sidebarMenuItems = [
    { text: "Dashboard", path: "/" }, 
    { text: "Carriers", path: "/carriers" }
 ];

export const barChartColors = ['#006BD6', '#EC407A', '#FFA726', '#26A69A', '#FF0000'];

export const allCarrierSearchColumnsText = "Carrier Name, Total Customer Price, Total Revenue, Total Profit";

export const carrierVersionSearchColumnsText = "Carrier Name, Total Customer Price, Total Revenue, Total Profit, Shipment Date";

export const searchColumns = ["totalCustomerPrice", "totalRevenue", "totalProfit", "name"]

export const lastDaysOptions = [
    { label: 'None', value: "none" },
    { label: '30', value: 30 },
    { label: '15', value: 15 },
    { label: '10', value: 10 },
];

export const chartColors = [
    '#006BD6', // Light Blue
    '#008000', // Normal Green
    '#D5006D', // Dark Pink
    '#800080', // Purple
    '#0000FF', // Simple Blue
    '#8B0000', // Dark Red
    '#006400', // Dark Green
    '#00008B', // Dark Blue
    '#FF8C00', // Dark Orange
    '#8A2BE2', // Blue Violet
    '#008B8B', // Dark Cyan
    '#8B008B', // Dark Magenta
    '#B8860B', // Dark Goldenrod
    '#8B4513', // Saddle Brown
    '#1E90FF', // Dodger Blue
    '#4B0082', // Indigo
    '#2E8B57', // Sea Green
    '#A52A2A', // Brown
    '#228B22', // Forest Green
    '#0000CD', // Medium Blue
    '#9ACD32', // Yellow Green
    '#D2691E', // Chocolate
  ];